import { z } from 'zod'

import { config } from '@/config'

export const tokenResponseSchema = z.object({
  accessToken: z.string(),
  refreshToken: z.string(),
})

export const emailPasswordAuth = async ({
  email,
  password,
}: {
  email: string
  password: string
}) => {
  const result = await fetch(`${config.services.api}/core/login/email`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    credentials: 'include',
    body: JSON.stringify({
      email,
      password,
    }),
  })

  if (!result.ok) {
    const data = await result.json()
    throw new Error(data.message ?? 'Could not login with email')
  }

  return tokenResponseSchema.parse(await result.json())
}
